<template>
  <div class="fts-html-viewer">
    <div class="html-viewer-iframe" ref="htmlViewerIframe" />

    <fts-btn
      color="primary" 
      text-transform-init
      box-shadow-none
      :loading="exporting" 
      class="export-btn" 
      @click="exportExcel"
    >
      <font-awesome-icon :icon="['fas', 'file-download']" /> Export to Excel
    </fts-btn>

    <fts-spinner :show="loading" fullScreen />
  </div>
</template>

<script>
import { clientStore } from "../store/clientStore"
import webAppConfig from "../commons/webApp.config";

import FTSBtn from "../elements/FTSBtn";
import FTSSpinner from "../elements/FTSSpinner";

var mime = require('mime-types');

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-spinner": FTSSpinner,
  },
  data: () => ({
    loading: false,
    exporting: false,
    moduleId: null,
  }),
  methods: {
    exportExcel() {
      let vm = this
      this.exporting = true;

      let queryModel = JSON.parse(this.urlSource)
      queryModel['outputType'] = 4;
      let xhr = new XMLHttpRequest();
      let token = JSON.parse(localStorage.getItem('ls.authorizationData'))['access_token'];
      const serviceAPI = "/service/PDFTemplateProcessing/document";
      xhr.open(
        'POST',
        webAppConfig.baseURL ? webAppConfig.baseURL + serviceAPI : serviceAPI,
        true
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader('authorization', 'bearer ' + token);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function () {
        if (this.status === 200) {
          var filename = "";
          var disposition = xhr.getResponseHeader('Content-Disposition');
          if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
          }
          var type = xhr.getResponseHeader('Content-Type');
          var blob;
          if (typeof File === 'function') {
            try {
              blob = new File([this.response], filename, { type: type });
            } catch (e) { /* Edge */ }
          }
          if (typeof blob === 'undefined') {
            blob = new Blob([this.response], { type: type });
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
          } else {
            var URL = window.URL || window.webkitURL;
            var downloadUrl = URL.createObjectURL(blob);
            /* export file name */
            let exportFileName = filename;
            if (!exportFileName) {
              exportFileName = "FETIAS-Export";
              if (vm.moduleName) exportFileName += `-${vm.moduleName}`;
              /* export file extension */
              const fileExtension = mime.extension(blob && blob.type);
              if (fileExtension) exportFileName += `.${fileExtension}`;
            }

            if (exportFileName) {
              // use HTML5 a[download] attribute to specify filename
              var a = document.createElement("a");
              // safari doesn't support this yet
              if (typeof a.download === 'undefined') {
                window.location = downloadUrl;
              } else {
                a.href = downloadUrl;
                a.download = exportFileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }
            } else {
              window.location = downloadUrl;
            }
            setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
          }
        } 

        vm.exporting = false;
      }
      xhr.send(JSON.stringify(queryModel));
    },
  },
  computed: {
    urlSource() {
      return this.$route.query && this.$route.query.file && this.$route.query.file.substring(55)
    },
    moduleName() {
      const findModule = clientStore.state.workspaceModules.find(x => x.id == this.moduleId);
      return findModule && findModule.name;
    },
  },
  async mounted() {
    this.loading = true
    try {
      if (this.urlSource) {
        /* set filename */
        try {
          const source = JSON.parse(this.urlSource);
          if (source.parameters.vectorId) {
            this.moduleId = source.parameters.vectorId;
            /* load workspace module */
            if (!this.moduleName) {
              await clientStore.dispatch("loadWorkspaceModule", {
                moduleId: this.moduleId,
                listId: source.parameters.list,
              });
            }
          }
        } catch(err) {
          console.error(err);
        }
        
        let res = await clientStore.dispatch("htmlTemplateProcess", this.urlSource)  
        if (res.data) {
          let iframe = this.$refs.htmlViewerIframe
          iframe.innerHTML = res.data;
        } else {
          throw 'error'
        }
      } else {
        throw 'error'
      }
    } catch(err) { 
      console.error(err) 
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-html-viewer {
  height: 100%;
  display: flex;
  flex-direction: column;
  .html-viewer-iframe {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    color: var(--fts-text);

  }
  .export-btn {
    position: fixed;
    top: 1rem;
    right: 1rem;
  }
}
</style>